import type { ThemeOption } from "@/constants";
import { getCurrentTheme } from "@/utils/theme";
import { AVATAR_COLORS } from "./colors";

function handleTextSelect(theme: ThemeOption) {
  const currentSelection = document.getSelection()?.toString();

  // rotate highlight color when selection text is empty
  if (currentSelection === "") {
    const randNum = Math.floor(Math.random() * AVATAR_COLORS.length);
    const invertColors = getCurrentTheme(theme) === "light";
    const docRoot = document.documentElement;
    const color = AVATAR_COLORS[randNum];
    docRoot.style.setProperty(
      "--color-foreground-highlight",
      invertColors ? color.bg : color.fg,
    );
    docRoot.style.setProperty(
      "--color-background-highlight",
      invertColors ? color.fg : color.bg,
    );
  }
}

export { handleTextSelect };
